import { Box, Divider, Typography } from "@mui/material";
import { Avatar } from "../../../components";
import { IUser } from "../../../models/user";
import IconAdmin from "@mui/icons-material/AdminPanelSettingsOutlined";
import IconManage from "@mui/icons-material/ManageAccountsOutlined";
import IconEmail from "@mui/icons-material/MailOutlineRounded";
import IconCake from "@mui/icons-material/CakeOutlined";
import IconPlace from "@mui/icons-material/PlaceOutlined";
import IconTag from "@mui/icons-material/BookmarkBorderRounded";
import IconPhone from "@mui/icons-material/PhoneOutlined";
import CommonHandle from "../../../common/handles/common.handles";
import { useTranslation } from "react-i18next";

type Props = {
  item: IUser;
};

function InfoRow(props: { title: string; content: string; icon: any }) {
  return (
    <Box className="info-row">
      <Box className="info-title">
        {props.icon}
        <p>{props.title}</p>
      </Box>
      <Typography variant="caption" className="info-content">
        {props.content}
      </Typography>
    </Box>
  );
}

const UserInformationBox = ({ item }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Box>
        <Typography variant="body2" fontWeight="600">
          {t("UserDetail.EmployeeInfoTitle")}
        </Typography>
        <Divider sx={{ margin: "8px 0" }} />
      </Box>
      <Box className="information">
        <Avatar
          src={item?.avatar}
          alt="Avatar-Image"
          width={"48px"}
          height={"48px"}
        />
        <Box className="information-name">
          <Typography variant="subtitle1">{item.fullName}</Typography>
          <Typography variant="body2">{item.userName}</Typography>
        </Box>
      </Box>

      <InfoRow
        title={t("UserDetail.PositionLabel")}
        content={item?.position ?? ""}
        icon={<IconTag />}
      />
      <InfoRow
        title={t("UserDetail.EmailLabel")}
        content={item.email}
        icon={<IconEmail />}
      />
      <InfoRow
        title={t("UserDetail.PhoneNumberLabel")}
        content={item?.phoneNumber ?? t("UserDetail.NoInfo")}
        icon={<IconPhone />}
      />
      <InfoRow
        title={t("UserDetail.BirthDateLabel")}
        content={
          item?.birthDay
            ? CommonHandle.formatDate(item?.birthDay)
            : t("UserDetail.NoInfo")
        }
        icon={<IconCake />}
      />
      <InfoRow
        title={t("UserDetail.AddressLabel")}
        content={item?.address ?? t("UserDetail.NoInfo")}
        icon={<IconPlace />}
      />
      <InfoRow
        title={t("UserDetail.DirectManagerLabel")}
        content={item?.manager?.fullName ?? t("UserDetail.NoManagerYet")}
        icon={<IconManage />}
      />
      <InfoRow
        title={t("UserDetail.RoleSelectLabel")}
        content={item.roles}
        icon={<IconAdmin />}
      />
    </>
  );
};

export default UserInformationBox;
